import { toast } from "../stores/toastStore.js";

const { showToast } = toast;

export async function fetchWrapper(url, options = {}) {
  const hasFormDataBody =
    typeof FormData !== "undefined" && options.body instanceof FormData;
  if (
    options.method &&
    ['POST', 'PATCH'].includes(options.method.toUpperCase()) &&
    !options.headers?.['Content-Type'] &&
    !hasFormDataBody
  ) {
    options.headers = { 'Content-Type': 'application/json', ...options.headers };
  }
  try {
     const response = await fetch(url, options);

    // A response body can only be read once, so the wrapper peeks at a clone
    // and hands the untouched original to the caller. Clone only where the
    // parsed value can actually be used: a successful GET never shows a toast,
    // and cloning it would buffer the whole payload for nothing.
    const showsSuccessToast =
      Boolean(options.method) &&
      options.method.toUpperCase() !== 'GET' &&
      !options.suppressSuccessToast;

    if (!response.ok) {
      let errorMsg = `Error: ${response.statusText}`;
      let data = null;
      try {
        data = await response.clone().json();
      } catch {
        // Error responses are not guaranteed to be JSON (for example, a
        // reverse proxy may return an HTML error page). Keep the response
        // available to the caller in that case.
        data = null;
      }
      if (data && (data.message || data.error)) errorMsg = data.message || data.error;
      // Optionale Module (Potential Scout, Monitoring) melden ihren Ausfall selbst
      // oder gar nicht: ein Fehler-Toast fuer einen nicht laufenden Nebendienst
      // verwirrt auf der Startseite nur (Kundenserver 03.09.2026).
      if (!options.suppressErrorToast) showToast(errorMsg, 'error', 'Error');
    }
    else if (showsSuccessToast) {
      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        let data = null;
        try {
          data = await response.clone().json();
        } catch {
          data = null;
        }
        if (data && data.message) {
          showToast(data.message, "success", "Success");
        }
      }
    }
    return response;

  } catch (error) {
    // A request cancelled because its view was left is expected, not a fault.
    // suppressErrorToast gilt auch hier: die oeffentliche Team-Umfrage meldete auf dem Handy sonst "Network error",
    // etwa wenn beim Wechsel der App ein Zwischenstand abbricht (04.10.2026)
    if (error?.name !== 'AbortError' && !options.suppressErrorToast) {
      showToast('Network error', "error", "Error");
    }
    throw error;
  }
}
